var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('v-chart',{ref:"lineChartObject",staticClass:"chart",attrs:{"autoresize":true,"option":_vm.lineOption,"update-options":{ notMerge: true }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }